import { clearUserData } from "globalResources/util";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

const Logout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    clearUserData(dispatch);
    setTimeout(() => window.location.replace("/dashboard"), 1000);
  }, [dispatch]);
  return <div>Logging You Out...</div>;
};
export default Logout;
